export default "__VITE_ASSET__1GF0t4Og__"